import React from 'react';
import { Switch as MuiSwitch, FormControlLabel } from '@mui/material';
import { colorPrimary } from '../../Styles/Colors';

const Switch = ({ checked, onChange, label, style = {}, ...props }) => {
 
  const responsiveStyle = {
    maxWidth: {
      xs: '34px',
      sm: '39px',
      md: '52px',
    },
    width: '100%',
    backgroundColor: 'rgba(96,19,80,1)',
    borderRadius: '100px',
    display: 'flex',
    flexDirection: {
      xs: 'row',
      sm: 'row',
      md: 'row',
    },
    justifyContent: 'flex-end',
    alignItems: 'center',
    pt: {
      xs: '1px',
      sm: '2px',
      md: '2px',
    },
    pb: {
      xs: '1px',
      sm: '2px',
      md: '2px',
    },
    pl: {
      xs: '2px',
      sm: '3px',
      md: '4px',
    },
    pr: {
      xs: '2px',
      sm: '3px',
      md: '4px',
    },
    height: '32px',
    ...style,
  
  };
  return (
    <FormControlLabel
      control={
        <MuiSwitch
          checked={checked}
          onChange={onChange}
          {...props}
          sx={{
            '& .MuiSwitch-switchBase': {
              color: style.color || '#fff',
              '&.Mui-checked': {
                color: style.color || '#fff',
                '& + .MuiSwitch-track': {
                  backgroundColor: style.backgroundColor || colorPrimary,
                },
              },
            },
            '& .MuiSwitch-track': {
              backgroundColor: style.backgroundColor || '#e0e0e0',
            },
            '& .MuiSwitch-thumb': {
              backgroundColor: '#fff',
            },
          }}
        />
      }
      // label={label}
      style={{ ...responsiveStyle, width:"fit-content",color:"white" }}
    />
  );
};

export default Switch;
